import { z } from 'zod';

export const DeleteFulfillmentProductUrlSchema = z.object({
    fulfillmentProductId: z.string().uuid(),
});
